// The limitation form vocabularies — `based_on` and `warning_unit` — shared by
// the inspection limitation form and the ADs / SBs tabs' New AD form (H104).
// Moved verbatim out of InspectionLImitationEdit.tsx; the notes below are its.
export const BASED_ON_OPTIONS: readonly string[] = [
  'Airframe Cycles',
  'Airframe Hoist Cycles',
  'Airframe Hook Cycles',
  'Airframe Hours',
  'Airframe Landings',
  'Date (Days)',
  'Date (Months)',
  'Date (Years)',
  'Engine 1 Hours',
  'Engine 1 ng Cycles',
  'Engine 1 np Cycles',
  'Engine 1 Start',
  'Engine 2 Hours',
  'Engine 2 ng Cycles',
  'Engine 2 np Cycles',
  'Engine 2 Start',
  'On Condition',
  // `Not Applicable` is the OTHER half of the backend's condition pair and it
  // was missing from this list, so a limitation could never be SET to it from
  // the UI although every read path already treats it specially:
  //   app/aircraft/schemas.py:680   _CONDITION_BASED_ON = {"On Condition", "Not Applicable"}
  //   app/aircraft/schemas.py:1652  the same pair again, as a tuple
  //   app/aircraft/crud.py:1337     `if based_on in ("On Condition", "Not Applicable")`
  // For both values Last Done, Next Due and Remaining render the literal `-`
  // and no arithmetic is attempted (legacy: pmltemplates/demo/mt/inspection.inc:202-204).
  // Purely ADDITIVE — no existing stored string changes meaning.
  'Not Applicable',
  'Propeller 1 Hours',
  'Propeller 2 Hours',
  'Landings',
  'Torque Events',
  'Untracked',
  'Hook Hours',
  // ⚠️ DO NOT "FIX" THE SPELLINGS IN THIS LIST. They are STORED VALUES, not
  // labels — they are written to `aircraft_inspection_log.based_on` and read
  // back by string equality. Renaming one orphans every existing row that
  // carries it.
  //
  // And the obvious-looking typo is not the one to worry about. Measured
  // against the axis map at app/techlog/remaining.py:25-50, which is the only
  // based_on -> column mapping in the tree:
  //   'Airframe Hoist Cycles'  IS a real key -> airframe_hoists   (NOT a typo,
  //                            despite the parity board calling it one)
  //   'Engine 1 Hours'         is NOT a key; the map says "Engine1 Hours"
  //   'Engine 1 ng Cycles'     is NOT a key; the map says "Engine1 Ng Cycles"
  //   'Engine 1 Start'         is NOT a key; the map says "Engine1 Starts"
  //   ...and the same for all four Engine 2 entries, plus 'Landings'
  //      (the map has only "Airframe Landings") and 'Hook Hours'.
  //   'Hois minutes'           appears in NO backend and NO legacy source.
  // So ~9 of these values cannot be resolved to an axis at all. That is a
  // bigger defect than a typo and it is NOT this lane's: reconciling it needs
  // `SELECT DISTINCT based_on FROM aircraft_inspection_log` on the live
  // tenant first, to learn which spelling the existing rows actually use.
  // Handed back as its own item.
  'Hois minutes'
]
export const WARNING_UNIT_OPTIONS: readonly string[] = [
  'Days',
  'Months',
  'Years',
  'Cycles',
  'Hours',
  'RINS',
  'Landings',
  'Starts',
  'Events',
  'Minutes',
  'Hook Hours'
]

export const DATE_BASED_ON_OPTIONS: readonly string[] = ['Date (Days)',
  'Date (Months)',
  'Date (Years)',]
